import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './component/HeroSection';
import Map from '../ContactPage/components/Map';
import HeroContent from './component/HeroContent';
import EarlyIntervention from './component/EarlyIntervention';
import MythTruth from './component/MythTruth';
import DyslexiaSigns from './component/DyslexiaSigns';
import PowerIntervention from './component/PowerIntervention';

const DyslexiaPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>Dyslexia | Guidepost Pediatrics Wasilla</title>
        <meta
          name="description"
          content="Dyslexia services in Wasilla, Alaska. Our dyslexia specialists help children with dyslexia. Call us today!"
        />
        <meta
          name="keywords"
          content="pediatric therapy contact Wasilla, schedule appointment Alaska, therapy evaluation Wasilla, Guidepost Pediatrics contact"
        />
      </Helmet>
      <HeroSection />
      <HeroContent />
      <EarlyIntervention />
      <MythTruth />
      <DyslexiaSigns />
      <PowerIntervention />
      <Map />
    </div>
  );
};

export default DyslexiaPage;
